import { useEffect } from 'react';

export function useLoadWysiwyg() {
  useEffect(() => {
    const filesToLoad = [
      'https://cdn.jsdelivr.net/npm/quill@1.3.7/dist/quill.js',
      'https://unpkg.com/quill-paste-smart@1.4.12/dist/quill-paste-smart.js',
    ];
    // Load them each in order (important)
    (async () => {
      for (const url of filesToLoad) {
        await new Promise(resolve => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          document.head.appendChild(script);
        });
      }
    })();

    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://cdn.jsdelivr.net/npm/quill@1.3.7/dist/quill.snow.css';
    document.head.appendChild(css);
  }, []);
}
